// extracted by mini-css-extract-plugin
export default {"main":"Sidebar_main__4TkrI","dropdown-menu":"Sidebar_dropdown-menu__aV+NY","p":"Sidebar_p__ptMrC","dropdown":"Sidebar_dropdown__BaT05"};